import React, { Component } from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import clsx from 'clsx'

import Icon from '../../GeneralComponents/Icon/Icon'
import uploadImg from '../../../assets/icons/upload-button.svg'

import { getRawMessage } from '../../../locale'
import { isRtl } from '../../../settings'
import { FormattedMessage, injectIntl } from 'react-intl'
import settings from '../../../settings'
import RawHtml from 'stories/components/RawHtml'

if (isRtl) {
  require('./file-input.rtl.css')
} else {
  require('./file-input.ltr.css')
}

const { locales } = settings

const defaultPlaceholder = (type) => (
  <FormattedMessage
    id="form.fields.file.placeholder"
    values={{ file: fileTypePlaceHolder[type] }}
  />
)
const fileTypePlaceHolder = {
  image: getRawMessage('form.fields.file.type.image'),
  document: getRawMessage('form.fields.file.type.document'),
  all: getRawMessage('form.fields.file.type.file'),
}
export const fileTypeOptions = [
  { value: 'image', label: getRawMessage('form.fields.file.type.image') },
  { value: 'document', label: getRawMessage('form.fields.file.type.document') },
  { value: 'all', label: getRawMessage('form.fields.file.type.all') },
  { value: 'custom', label: getRawMessage('form.fields.file.type.custom') },
]

class FileInput extends Component {
  constructor(props) {
    super(props)
    this.state = { hasFocus: false, hasFile: false }
  }

  onInputChange = (event) => {
    const { files } = event.target
    if (files.length > 0) {
      this.setState({ hasFile: true })
      this.props.onChange(files[0])
      this.onInputBlur()
      this.props.showImagePreview && this.generateImagePreviewSrc(files[0])
    } else {
      this.setState({ hasFile: false })
      this.props.onChange(null)
      this.onInputBlur()
    }
  }

  resetField = (event) => {
    event.stopPropagation()
    event.preventDefault()

    this.setState(
      {
        hasFocus: false,
        hasFile: false,
      },
      () => {
        this.props.onChange(null)
        if (this.fileInput) {
          this.fileInput.value = ''
        }
      }
    )
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  inputMeta = () => {
    if (this.fileInput && this.props.file_type !== 'image') {
      const files = this.fileInput.files
      if (files.length > 0) {
        return files[0].name
      }
      return ''
    } else {
      return ''
    }
  }

  getAllowedFileType = (fileType) => {
    switch (fileType) {
      case 'image':
        return {
          humanReadable: (
            <span>
              (
              <FormattedMessage id="form.fields.file.type.image" />)
            </span>
          ),
          browserReadable: 'image/*',
        }

      case 'document':
        return {
          humanReadable: (
            <span>
              (
              <FormattedMessage id="form.fields.file.type.document" />)
            </span>
          ),
          browserReadable: '.txt,.pdf,.doc,.docx,xls,.xlsx,.ppt,.pptx',
        }

      case 'all':
        return { humanReadable: '', browserReadable: '*' }

      default:
        return {}
    }
  }

  generateDescription = (desc, maxSize) => {
    if (!this.applyMasking() || !maxSize) return <RawHtml content={desc} />

    return (
      <span>
        <RawHtml content={desc} />
        <span className="form-field-limit">
          (
          <FormattedMessage
            id="form.fields.file.sizeLimit"
            values={{ size: maxSize }}
          />
          )
        </span>
      </span>
    )
  }

  generateImagePreviewSrc = (imageFile) => {
    if (imageFile && typeof imageFile === 'object') {
      const reader = new FileReader()

      reader.onload = (e) => {
        this.setState({
          imageSrc: e.target.result,
        })
      }

      reader.readAsDataURL(imageFile)
    }
  }

  applyMasking = () => {
    const {
      intl: { locale = locales.fa },
    } = this.props
    if (locale === locales.fa) return true

    return false
  }

  render() {
    const {
      label = '',
      name = '',
      file_type: accept,
      required,
      touched,
      error,
      description,
      placeholder,
      hideTitle,
      hideIcon,
      max_size,
    } = this.props

    const classNames = {
      'formz-file-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }

    const fileInputClassnames = clsx({
      'formz-file-input-button-wrapper': true,
      'formz-input-field': true,
      // 'formz-file-has-file': this.state.hasFile,
      'hide-background': this.props.value && accept === 'image',
    })

    const shouldShowImagePreview =
      this.props.showImagePreview &&
      (this.state.hasFile || typeof this.props.value === 'string')
    return (
      <FieldRowWrapper
        className={classNames}
        error={error}
        touched={touched ? touched.toString() : undefined}
      >
        <label className="formz-field-and-label-holder">
          {!hideTitle && (
            <div className="formz-input-title">
              {label} {this.getAllowedFileType(accept).humanReadable}{' '}
              {required && '(*)'}
            </div>
          )}

          {shouldShowImagePreview && (
            <img
              src={this.state.imageSrc || this.props.value}
              alt=""
              className="formz-image-file-preview"
            />
          )}

          {this.props.value && (
            <div
              className="formz-file-input-close-button"
              onClick={this.resetField}
            >
              &#10006;
            </div>
          )}

          <div className="formz-field-description">
            {this.generateDescription(description, max_size)}
          </div>

          <div className={fileInputClassnames}>
            {!this.state.hasFile && !this.props.value && (
              <span className="formz-call-to-action">
                {placeholder || defaultPlaceholder(accept)}
              </span>
            )}

            <span className="formz-file-meta"> {this.inputMeta()}</span>

            {!hideIcon && <Icon className="formz-file-icon" src={uploadImg} />}

            {/* this input is HIDDEN 🔱 */}
            <input
              type="file"
              tabIndex="-1"
              name={name}
              ref={(el) => {
                this.fileInput = el
              }}
              accept={this.getAllowedFileType(accept).browserReadable}
              className="formz-input-field file"
              onChange={this.onInputChange}
              onBlur={this.onInputBlur}
              onFocus={this.onInputFocus}
              disabled={this.props.isPreview}
            />
          </div>
        </label>
      </FieldRowWrapper>
    )
  }
}

export default injectIntl(FileInput)
